/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-cond-assign */
import { isNullOrUndefined } from "/Assets/js/utilities.js";
import { Bouncer } from "/Assets/libs/bouncer-es6.js";
import * as tomSelect from "/Assets/libs/TomSelect/tom-select.complete.js";

document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".platesaver-cost-savings-calculator")) {
        const platesaver = new Platesaver();
        platesaver.init();
    }
});

class Platesaver {
    constructor() { }

    init() {
        this.$element = $(".platesaver-cost-savings-calculator");
        if (!this.$element.length)
            return;

        this.$form = this.$element.find("#platesaver-cost-savings-calculator-form");
        this.$resultsCntnr = this.$element.find(".platesaver-cost-savings-results");
        this.$overlayCntnr = this.$element.find(".overlay");
        this.$arrowBkgnd = this.$element.find(".arrow-background");
        this.locale = this.$element.data("locale");

        if (isNullOrUndefined(this.locale)) {
            this.locale = this.getBrowserLocale();
        }

        const unit = this.getUnitOfMeasurementValue();
        this.initializeSelects();
        this.setFieldDefaults(unit, false);
        this.setupFormValidation();
        this.bindEvents();
    }

    bindEvents() {
        const self = this;

        self.$element.find("input[name='unit-of-measurement']").on("change",
            function () {
                const unit = $(this).val();
                self.setFieldDefaults(unit, true);
            });

        self.$element.find("#recalculate-plate-usage").on("click",
            function (e) {
                e.preventDefault();
                self.$resultsCntnr.hide();
                self.$overlayCntnr.hide();
                self.$arrowBkgnd.css({ "opacity": "1" }).scrollIntoView(120);

            });

        self.$element.find("#print-results").on("click",
            function (e) {
                e.preventDefault();
                window.print();
            });

        document.addEventListener("bouncerFormValid", function (event) {
            if (event.target.classList.contains("platesaver-cost-savings-calculator-form")) {
                self.calculateCostSavings();
                self.$arrowBkgnd.css({ "opacity": ".5" });
                self.$overlayCntnr.show();
                self.$resultsCntnr.show().scrollIntoView(120);

            }
        }, false);
    }

    initializeSelects() {
        var selects = this.$form.find("select");
        selects.each(function () {
            new tomSelect($(this)[0], {});
        });
    }

    replaceSelectOptions(selectid, options, selected) {
        const select = document.querySelector(selectid);
        select.innerHTML = "";
        options.forEach(item => {
            const optionElement = document.createElement("option");
            optionElement.value = item.value;
            optionElement.text = item.text;
            if (item.value === selected) {
                optionElement.selected = true;
            }
            select.add(optionElement);
        });

        const tomselect = select.tomselect;
        if (tomselect) {
            tomselect.clear();
            tomselect.clearOptions();
            tomselect.sync();
            tomselect.setValue(selected);
        }
    }

    setFieldDefaults(unit, change) {
        var thicknessOptions = imperialOptions;
        var selectedThickness = "0.5";
        var selector = "data-default-imperial";
        var resultLabelSelector = "data-imperial-label";
        var inputAddonUnit = "in";

        if (unit === "mm") {
            selector = "data-default-metric";
            thicknessOptions = metricOptions;
            selectedThickness = "12";
            inputAddonUnit = "mm";
        }

        var priceRawMaterial = parseFloat($("#price-raw-material").attr(selector));
        var lengthOfPlate = this.formatNumberForCalculation($("#length-of-plate").attr(selector));
        var widthOfPlate = this.formatNumberForCalculation($("#width-of-plate").attr(selector));
        var annualPlateUsage = this.formatNumberForCalculation($("#annual-plate-usage").attr("data-default-value"));
        var currentPlateUtilization = parseInt($("#current-plate-utilization").attr("data-default-value"));

        //console.log("Unformatted defaults",
        //    { priceRawMaterial, lengthOfPlate, widthOfPlate, annualPlateUsage, currentPlateUtilization });

        const fPriceRawMaterial = this.numberFormatter(priceRawMaterial);
        const fLengthOfPlate = this.numberFormatter(lengthOfPlate);
        const fWidthOfPlate = this.numberFormatter(widthOfPlate);
        const fAnnualPlateUsage = this.numberFormatter(annualPlateUsage);
        const fCurrentPlateUtilization = currentPlateUtilization;

        //console.log("Formatted defaults",
        //    { fPriceRawMaterial, fLengthOfPlate, fWidthOfPlate, fAnnualPlateUsage, fCurrentPlateUtilization });

        $("#price-raw-material").val(fPriceRawMaterial);
        $("#length-of-plate").val(fLengthOfPlate);
        $("#width-of-plate").val(fWidthOfPlate);
        $("#annual-plate-usage").val(fAnnualPlateUsage);
        $("#current-plate-utilization").val(fCurrentPlateUtilization);

        //Update label for selected unit
        const $priceRawMaterialElement = $("#priceRawMaterialLabel");
        if (unit === "mm") {
            $priceRawMaterialElement.text($priceRawMaterialElement.data("label-metric"));
        } else {
            $priceRawMaterialElement.text($priceRawMaterialElement.data("label-imperial"));
        }

        $("[data-input-addon-unit]").text(inputAddonUnit);
        if (change) {
            this.replaceSelectOptions("#plate-thickness", thicknessOptions, selectedThickness);
        }

        // change result labels
        if (unit === "mm") {
            resultLabelSelector = "data-metric-label";
        }
        $("[data-imperial-label]").each(function () {
            const label = $(this).attr(resultLabelSelector);
            $(this).html(label);
        });
    }

    getUnitOfMeasurementValue() {
        const value = $("input[name='unit-of-measurement']:checked").val();
        return value;
    }

    getBrowserLocale(options = {}) {
        const defaultOptions = {
            languageCodeOnly: false
        };

        const opt = {
            defaultOptions,
            options
        };

        const browserLocales =
            navigator.languages === undefined
                ? [navigator.language]
                : navigator.languages;

        if (!browserLocales) {
            return undefined;
        }

        const cleanedLocales = browserLocales.map(locale => {
            const trimmedLocale = locale.trim();

            return opt.languageCodeOnly
                ? trimmedLocale.split(/-|_/)[0]
                : trimmedLocale;
        });

        return cleanedLocales[0];
    }

    setupFormValidation() {
        const self = this;
        let bouncer = new Bouncer("[data-validate]", {
            disableSubmit: true,
            messages: {
                missingValue: {
                    checkbox: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    radio: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    select: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    "select-multiple": window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                },
                patternMismatch: {
                    email: window.jsl10n.JsResources.Translations.Common.EnterValidEmailAddress,
                    number: window.jsl10n.JsResources.Translations.Common.EnterValidNumber,
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                }
            }
        });
        self.bouncer = bouncer;
    }

    formatNumberForCalculation(string) {
        const parser = new NumberParser(this.locale);
        return parser.parse(string);
    }

    percentageFormatter(num) {
        return new Intl.NumberFormat(this.locale, {
            style: "percent",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    }

    numberFormatter(num) {
        return new Intl.NumberFormat(this.locale).format(num);
    }

    setPercentResultField(field, value) {
        const str = this.percentageFormatter(value);
        this.$element.find(field).text(str);
    }

    setResultField(field, value) {
        const str = this.numberFormatter(value);
        this.$element.find(field).text(str);
    }

    calculatePercentage(num, per) {
        return (num / 100) * per;
    }

    calculateCostSavings() {
        var unitOfMeasurement = this.getUnitOfMeasurementValue();

        var priceRawMaterial = this.formatNumberForCalculation($("#price-raw-material").val());
        var lengthOfPlate = this.formatNumberForCalculation($("#length-of-plate").val());
        var widthOfPlate = this.formatNumberForCalculation($("#width-of-plate").val());
        var annualPlateUsage = this.formatNumberForCalculation($("#annual-plate-usage").val());
        var currentPlateUtilization = parseInt($("#current-plate-utilization").val());
        var plateThickness = parseFloat($("#plate-thickness").val());
        var expectedPlateUtilization = parseInt($("#expected-plate-utilization").val());

        //console.log("Values for calculation",
        //    { priceRawMaterial, lengthOfPlate, widthOfPlate, annualPlateUsage, currentPlateUtilization, plateThickness, expectedPlateUtilization });

        this.setResultField("[data-total-plates-used]", annualPlateUsage);

        const totalLbsThroughputImperial = 0.2833;
        const totalLbsThroughputMetric = 0.0079;
        var totalLbsThroughput = totalLbsThroughputImperial;
        if (unitOfMeasurement === "mm") {
            totalLbsThroughput = totalLbsThroughputMetric;
        }

        //C15 priceRawMaterial
        //C16 plateThickness
        //C17 lengthOfPlate
        //C18 widthOfPlate
        //C19 annualPlateUsage
        //C20 currentPlateUtilization
        //C21 expectedPlateUtilization

        const ppTempImperial = plateThickness * lengthOfPlate * widthOfPlate * annualPlateUsage * totalLbsThroughput;
        const ppTempMetric = (plateThickness * lengthOfPlate * widthOfPlate / 1000) *
            annualPlateUsage *
            totalLbsThroughput;
        var ppTemp = ppTempImperial;
        if (unitOfMeasurement === "mm") {
            ppTemp = ppTempMetric;
        }
        const partsProduced = this.calculatePercentage(ppTemp, currentPlateUtilization);
        const partsProducedDisplay = Math.round(partsProduced);
        this.setResultField("[data-parts-produced]", partsProducedDisplay);

        const utilizationRate = (currentPlateUtilization + expectedPlateUtilization) / 100;
        const estimatedTotalPlatesUsedImperial = partsProduced /
            utilizationRate /
            (plateThickness * lengthOfPlate * widthOfPlate * totalLbsThroughput);
        const estimatedTotalPlatesUsedMetric = partsProduced /
            utilizationRate /
            (plateThickness * lengthOfPlate * widthOfPlate * totalLbsThroughput) *
            1000;
        var estimatedTotalPlatesUsed = estimatedTotalPlatesUsedImperial;
        if (unitOfMeasurement === "mm") {
            estimatedTotalPlatesUsed = estimatedTotalPlatesUsedMetric;
        }
        const estimatedTotalPlatesUsedDisplay = Math.round(estimatedTotalPlatesUsed);
        this.setResultField("[data-total-plates-used-estimated]", estimatedTotalPlatesUsedDisplay);

        const spTempImperial = plateThickness * lengthOfPlate * widthOfPlate * annualPlateUsage * totalLbsThroughput;
        const spTempMetric = (plateThickness * lengthOfPlate * widthOfPlate / 1000) *
            annualPlateUsage *
            totalLbsThroughput;
        const scrapProducedCurrentImperial = spTempImperial * (1 - (currentPlateUtilization / 100));
        const scrapProducedCurrentMetric = spTempMetric * (1 - (currentPlateUtilization / 100));
        var scrapProducedCurrent = scrapProducedCurrentImperial;
        if (unitOfMeasurement === "mm") {
            scrapProducedCurrent = scrapProducedCurrentMetric;
        }
        const scrapProducedCurrentDisplay = Math.round(scrapProducedCurrent);
        this.setResultField("[data-scraps-produced-current]", scrapProducedCurrentDisplay);

        const scrapProducedEstimatedImperial =
            (estimatedTotalPlatesUsed * plateThickness * lengthOfPlate * widthOfPlate * totalLbsThroughput) -
            partsProduced;
        const scrapProducedEstimatedMetric =
            ((plateThickness * lengthOfPlate * widthOfPlate / 1000) * estimatedTotalPlatesUsed * totalLbsThroughput) -
            partsProduced;
        var scrapProducedEstimated = scrapProducedEstimatedImperial;
        if (unitOfMeasurement === "mm") {
            scrapProducedEstimated = scrapProducedEstimatedMetric;
        }
        const scrapProducedEstimatedDisplay = Math.round(scrapProducedEstimated);
        this.setResultField("[data-scraps-produced-estimated]", scrapProducedEstimatedDisplay);

        const percentScrapReduction = ((scrapProducedCurrent - scrapProducedEstimated) / scrapProducedCurrent);
        this.setPercentResultField("[data-percent-scrap-reduction]", percentScrapReduction);

        const costPerPlateImperial =
            priceRawMaterial * plateThickness * lengthOfPlate * widthOfPlate * totalLbsThroughput;
        const costPerPlateMetric = ((scrapProducedCurrent + partsProduced) * priceRawMaterial) / annualPlateUsage;
        var costPerPlate = costPerPlateImperial;
        if (unitOfMeasurement === "mm") {
            costPerPlate = costPerPlateMetric;
        }

        const costPerPlateDisplay = Math.round(costPerPlate);
        this.setResultField("[data-cost-per-plate]", costPerPlateDisplay);

        const materialCostCurrent = annualPlateUsage * costPerPlate;
        const materialCostCurrentDisplay = Math.round(materialCostCurrent);
        this.setResultField("[data-material-cost-current]", materialCostCurrentDisplay);

        const materialCostEstimated = estimatedTotalPlatesUsed * costPerPlate;
        const materialCostEstimatedDisplay = Math.round(materialCostEstimated);
        this.setResultField("[data-material-cost-estimated]", materialCostEstimatedDisplay);

        const estimatedSavings = Math.round(materialCostCurrent - materialCostEstimated);
        this.setResultField("[data-estimated-savings]", estimatedSavings);

        const lbsScrapPerFootOfCut = 3.72;
        const thickness = .75;
        const kgCo2EFtCut = 1.09;
        const kgCo2ELbScrap = kgCo2EFtCut / lbsScrapPerFootOfCut;
        const kgCo2ELbScrapInchOfThickness = kgCo2ELbScrap / thickness;

        const emissionsSavedImperial =
            ((scrapProducedCurrent - scrapProducedEstimated) * plateThickness * kgCo2ELbScrapInchOfThickness) * 2.2046;
        const emissionsSavedMetric = ((scrapProducedCurrent - scrapProducedEstimated) * 2.2046) *
            (plateThickness / 25.4) *
            kgCo2ELbScrapInchOfThickness;
        var emissionsSaved = emissionsSavedImperial;
        if (unitOfMeasurement === "mm") {
            emissionsSaved = emissionsSavedMetric;
        }
        const emissionsSavedDisplay = Math.round(emissionsSaved);
        this.setResultField("[data-co2-emissions-saved]", emissionsSavedDisplay);

        const equivalentConsumptionGasolineImperial = Math.round(emissionsSaved / 19.64);
        const equivalentConsumptionGasolineMetric = Math.round(emissionsSaved / 2.3);
        var equivalentConsumptionGasoline = equivalentConsumptionGasolineImperial;
        if (unitOfMeasurement === "mm") {
            equivalentConsumptionGasoline = equivalentConsumptionGasolineMetric;
        }
        this.setResultField("[data-equivalent-consumption-gasoline]", equivalentConsumptionGasoline);
    }
}

const imperialOptions = [
    { text: "1/2 in", value: "0.5" },
    { text: "5/8 in", value: "0.625" },
    { text: "3/4 in", value: "0.75" },
    { text: "7/8 in", value: "0.875" },
    { text: "1 in", value: "1" },
    { text: "1 1/8 in", value: "1.125" },
    { text: "1 1/4 in", value: "1.25" }
];

const metricOptions = [
    { text: "12 mm", value: "12" },
    { text: "17 mm", value: "17" },
    { text: "20 mm", value: "20" },
    { text: "22 mm", value: "22" },
    { text: "25 mm", value: "25" },
    { text: "28 mm", value: "28" },
    { text: "32 mm", value: "32" }
];

class NumberParser {
    constructor(locale) {
        const format = new Intl.NumberFormat(locale);
        const parts = format.formatToParts(12345.6);
        const numerals = Array.from({ length: 10 }).map((_, i) => format.format(i));
        const index = new Map(numerals.map((d, i) => [d, i]));
        this._group = new RegExp(`[${parts.find(d => d.type === "group").value}]`, "g");
        this._decimal = new RegExp(`[${parts.find(d => d.type === "decimal").value}]`);
        this._numeral = new RegExp(`[${numerals.join("")}]`, "g");
        this._index = d => index.get(d);
    }
    parse(string) {
        return (string = string.trim()
            .replace(this._group, "")
            .replace(this._decimal, ".")
            .replace(this._numeral, this._index)) ? +string : NaN;
    }
}
